import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function getGroups({search}) {
  try{
    const data = await axios.get(`${REACT_APP_API}/groups/${search}`) 
    return data?.data
  }catch(error){
      throw new Error(error)
  }
}
